export const isVideo = (file: File | string) => {
  const type = typeof file === 'string' ? file : file.type;
  return /^video\/.+$/.test(type);
};

export const isPhoto = (file: File | string) => {
  const type = typeof file === 'string' ? file : file.type;
  return /^image\/.+$/.test(type);
};
